import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Default theme
const DEFAULT_THEME = {
  theme_id: 'padrao',
  theme: {
    name: 'Padrão',
    background: '#ffffff',
    backgroundLight: '#f8fafc',
    primary: '#003366',
    secondary: '#FFD700',
    text: '#1f2937',
    headerBg: '#ffffff',
    footerBg: '#003366',
    footerText: '#d1d5db'
  },
  logo_image: null,
  ribbon_image: null,
  footer_image: null
};

const ThemeContext = createContext({
  themeConfig: DEFAULT_THEME,
  loading: true,
  refreshTheme: () => {}
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [themeConfig, setThemeConfig] = useState(DEFAULT_THEME);
  const [loading, setLoading] = useState(true);

  const fetchTheme = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/themes/active`);
      if (response.data) {
        setThemeConfig(response.data);
      }
    } catch (error) {
      console.error('Error fetching theme:', error);
      setThemeConfig(DEFAULT_THEME);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTheme();
  }, []);

  // Apply CSS variables when theme changes
  useEffect(() => {
    if (themeConfig?.theme) {
      const root = document.documentElement;
      const theme = themeConfig.theme;
      
      root.style.setProperty('--theme-background', theme.background || '#ffffff');
      root.style.setProperty('--theme-background-light', theme.backgroundLight || '#f8fafc');
      root.style.setProperty('--theme-primary', theme.primary || '#003366');
      root.style.setProperty('--theme-secondary', theme.secondary || '#FFD700');
      root.style.setProperty('--theme-text', theme.text || '#1f2937');
      root.style.setProperty('--theme-accent-text', theme.accentText || theme.text || '#1f2937');
      root.style.setProperty('--theme-header-bg', theme.headerBg || '#ffffff');
      root.style.setProperty('--theme-footer-bg', theme.footerBg || '#003366');
      root.style.setProperty('--theme-footer-text', theme.footerText || '#d1d5db');
    }
  }, [themeConfig]);

  const refreshTheme = () => {
    setLoading(true);
    fetchTheme();
  };

  return (
    <ThemeContext.Provider value={{ themeConfig, loading, refreshTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
